import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Subject } from 'rxjs'
import { BadgeEditorService } from '../../services/badge-editor.service'
import { FormGroup } from '@angular/forms'
import { TemplateLayout, VariableElementResponse } from '../../types/badge.type'
import { BadgeElement } from '../../models/badge-variable-elements.model'
import { BADGE_SIDES, TOOLBAR_ACTIONS } from '../../enums/badge.enum'
import { takeUntil } from 'rxjs/operators'
import { CommonModule } from '@angular/common'
import { VariableElementsListComponent } from './variable-elements-list/variable-elements-list.component'
import { BadgeAreaComponent } from './badge-area/badge-area.component'
@Component({
  selector: 'app-name-badge',
  templateUrl: './name-badge.component.html',
  styleUrls: ['./name-badge.component.scss'],
  standalone: true,
  imports: [CommonModule, VariableElementsListComponent, BadgeAreaComponent]
})
export class NameBadgeComponent implements OnInit {
  // TODO nnn
  @Input() public persona!: any
  @Input() public badgeForm!: FormGroup
  @Input() public variableElementsData!: VariableElementResponse[]
  @Input() public parentVariableElementsData!: VariableElementResponse[]
  @Output() public backToPersonaSelection: EventEmitter<void> = new EventEmitter<void>()
  public selectedTemplate!: TemplateLayout | null
  public variableElements!: BadgeElement[]
  public parentVariableElements!: BadgeElement[]
  public currentSide: BADGE_SIDES = BADGE_SIDES.FRONT_SIDE
  private _destroy$ = new Subject<void>()
  private _prevTemplate!: TemplateLayout

  private _blockElementsTypes: string[] = ['category', 'warn_line', 'checkbox', 'info_line', 'line_separator', 'star_rating']

  constructor(private _BadgeService: BadgeEditorService) {}

  ngOnInit(): void {
    this._getVariableElements()
    if (this.badgeForm.value?.badge_front_html_content) this.selectedTemplate = null
    this._BadgeService.toolbarAction$.pipe(takeUntil(this._destroy$)).subscribe(({ action, payload }) => {
      switch (action) {
        case TOOLBAR_ACTIONS.SWITCH_SIDE:
          this.currentSide = payload as BADGE_SIDES
          break
        case TOOLBAR_ACTIONS.START_OVER:
          this._changeTemplate()
          break
      }
    })
  }

  ngOnDestroy(): void {
    this._destroy$.next()
    this._destroy$.complete()
  }

  /**
   * @method _getVariableElements
   * @description Fetch the variable elements for the badge and create the elements via the service using variable elements model data
   * @param eventId number
   * @param personaId number
   * @returns void
   */
  private _getVariableElements(): void {
    if (!this._BadgeService.isDTCM) this._blockElementsTypes.push('dtcm_qr_code')
    this.variableElements = this._BadgeService
      .createVariableElements(this.variableElementsData, this.persona.name.toUpperCase())
      .filter((element) => !this._blockElementsTypes.some((type) => element.field_type.startsWith(type)))

    this.parentVariableElements = this._BadgeService
      .createVariableElements(this.parentVariableElementsData, this.persona.parentName?.toUpperCase())
      .filter((element) => !this._blockElementsTypes.some((type) => element.field_type.startsWith(type)))
  }

  /**
   * @description Change the template for the badge
   */
  private _changeTemplate(): void {
    this._prevTemplate = { ...(this.selectedTemplate as TemplateLayout) }
    this.selectedTemplate = null
  }

  /**
   * @description Cancel the template selection
   */
  public onCancelTemplateSelection(): void {
    this.selectedTemplate = { ...this._prevTemplate }
  }

  /**
   * @method selectTemplate
   * @description Select the template for the badge
   * @param id number
   * @returns void
   */
  public selectTemplate(badgeData: TemplateLayout): void {
    this.selectedTemplate = badgeData
    this._BadgeService.selectedTemplate = badgeData
  }

  /**
   * @method goBackToPersonaSelection
   * @description Emit event to go back to persona selection
   * @returns void
   */
  public goBackToPersonaSelection(): void {
    this.backToPersonaSelection.emit()
  }
}
